import * as Api from './service'
export default {
  namespace: 'ServiceScoreDetail',
  state: {
    loadingVisible: true,
    detailList: [],
    statPeriod: {}
  },
  effects: {
    * queryPointSourceDetail ({ payload }, { call, put }) {
      const {
        data: {
          data: { detailList, statPeriod }
        }
      } = yield call(Api.queryPointSourceDetail, payload)
      yield put({
        type: 'save',
        payload: {
          loadingVisible: false,
          detailList,
          statPeriod
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
